import { render, staticRenderFns } from "./col-content.vue?vue&type=template&id=b83be6c2&"
import script from "./col-content.vue?vue&type=script&lang=js&"
export * from "./col-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports